import { fetchPagesByRoleId } from '../../services/RbacService'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import {
    NAV_ITEM_TYPE_TITLE,
} from "constants/navigation.constant";

export const getPages = createAsyncThunk('pages/List',async () => {
  const response = await fetchPagesByRoleId();
  return response.data.result;
})

export const initialState = {
    avatar: '',
    userName: '',
    email: '',
    authority: [],
    pages : [],
    loading : false,
    trasactionList:[],
    transactionStatus:[],
    transactionFlow:[]
   
}

export const userSlice = createSlice({
	name: 'auth/user',
	initialState, 
	reducers: {
    
        setUser: (_, action) =>{
          return  action.payload},
        setNav: (state, action) =>  {
            state.nav = action.payload
        },
        userLoggedOut: () => initialState,
        setTransactionList: (state, action) => { // Fixed the typo here (setTrasactionList -> setTransactionList)
          state.trasactionList = action.payload // Corrected the mutation to 'transactionList'
        },
        setTransactionStatus: (state, action) => { // Fixed the typo here (setTrasactionList -> setTransactionList)
          state.transactionStatus = action.payload // Corrected the mutation to 'transactionList'
        },
        setTransactionFlow(state,action){
          state.transactionFlow=action.payload
        }
	},
  extraReducers: {
    [getPages.fulfilled]: (state, action) => {
        state.pages = action.payload
        state.loading = false
    },
    [getPages.pending]: (state) => {
        state.loading = true
    },
    [getPages.rejected]: (state) => {
      state.loading = false
  },
}
})

export const { setUser, setNav,setTransactionList,setTransactionStatus,setTransactionFlow } = userSlice.actions

export default userSlice.reducer